var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",{"transform":"translate(-488 -2825) translate(488 2825)"},[React.createElement("path",{"d":"M0 0H44V44H0z","key":0}),React.createElement("circle",{"cx":"22","cy":"22","r":"21","fill":"#f1f1f1","stroke":"#f1f1f1","strokeWidth":"2","key":1}),React.createElement("path",{"fill":"#000","d":"M23.315 35h-4.878V23.499H16v-3.963h2.437v-2.38c0-3.233 1.376-5.156 5.286-5.156h3.255v3.964h-2.034c-1.523 0-1.623.554-1.623 1.588l-.007 1.984H27l-.431 3.963h-3.255V35z","key":2})]))));
}

Facebook.defaultProps = {"width":"34","height":"34","viewBox":"0 0 44 44"};

module.exports = Facebook;

Facebook.default = Facebook;
